import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { FooterComponent } from "../../shared/components/footer/footer.component";
import { ToastrService } from "ngx-toastr";
import { CollectionService } from "../../components/collections/collection.service";
import { StorageService } from "../../shared/services/storage.service";
import { LayoutService } from "../../shared/services/layout.service";

@Component({
  selector: "app-new-password",
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule, TranslateModule, FooterComponent],
  templateUrl: "./new-password.component.html",
  styleUrl: "./new-password.component.scss",
})
export class NewPasswordComponent implements OnInit {
  newPasswordForm: FormGroup;
  public show: boolean = false;
  public showRepeat: boolean = false;
  private oldPwd: string = "";
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private collectionService: CollectionService,
    private storageService: StorageService, 
    private loaderService: LayoutService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.oldPwd = history.state.oldPwd;
    this.newPasswordForm = this.fb.group(
      {
        newPassword: ["", [Validators.required]],
        repeatPassword: ["", [Validators.required]],
      },
      { validators: this.checkPasswords }
    );
  }

  checkPasswords(group: FormGroup) {
    const password = group.get("newPassword")?.value;
    const repeatPassword = group.get("repeatPassword")?.value;
    return password === repeatPassword ? null : { notSame: true };
  }

  resetPassword() {
    let user = this.storageService.getFromLocalOrSessionStorage("tempUser");
    let payload = {
      current_password: this.oldPwd,
      password: this.newPasswordForm.get("newPassword")?.value,
      password_confirmation: this.newPasswordForm.get("repeatPassword")?.value
    }
    this.loaderService.show();
    this.collectionService.resetPswUser(payload).subscribe({
      next: (res: any) => {
        this.toastrService.success(res.message);
        this.router.navigate(["/auth/login"]);
        this.loaderService.hide();
      },
      error: (error) => {
        this.loaderService.hide();
      },
    })
  }
}
